"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.success.completed': 'Onboarding completato con successo! Il tuo assistente IA è pronto.',
    'onboarding.success.progress_saved': 'Progresso salvato con successo',
};
